import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Brand } from "@/components/Brand";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#F1F4F3] flex flex-col items-center justify-center px-6 text-center">
      <div className="mb-10"><Brand size={40} /></div>
      <div className="max-w-md" data-testid="payment-cancel">
        <XCircle size={48} className="text-[#556673] mx-auto mb-6" />
        <h1 className="font-display font-black text-4xl mb-3 text-[#0E1E2E]">Checkout cancelled</h1>
        <p className="text-[#556673] mb-8">No worries — you weren't charged. The ebook is still here whenever you're ready.</p>
        <Link to="/#ebooks" className="inline-block px-8 py-4 bg-brand text-[#06111C] font-display font-bold uppercase tracking-wide text-sm hover:bg-[#27B95B] transition-colors">
          Back to ebooks
        </Link>
      </div>
    </div>
  );
}
